export const descriptionText =
  'Enter a suburb or postcode to find a store near you.';

export const titleTheme = 'Sportscraft';
